import React, { useEffect } from 'react';
import Icon from '../AppIcon';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const styles = {
    success: {
      bg: 'bg-success',
      text: 'text-success-foreground',
      icon: 'CheckCircle'
    },
    error: {
      bg: 'bg-error',
      text: 'text-error-foreground',
      icon: 'XCircle'
    }
  };

  const style = styles?.[type] || styles?.success;

  return (
    <div className="fixed top-20 right-4 z-[9999] animate-slide-in-right">
      <div className={`${style?.bg} ${style?.text} rounded-lg shadow-lg p-4 flex items-center gap-3 min-w-[300px] max-w-md`}>
        <Icon name={style?.icon} className="w-5 h-5 flex-shrink-0" />
        <p className="flex-1 font-medium">{message}</p>
        <button
          onClick={onClose}
          className="flex-shrink-0 hover:opacity-80 transition-opacity"
          aria-label="Close notification"
        >
          <Icon name="X" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Toast;